// setup all vue plugins etc here so we can use them both from main
// and tests
import Vue from 'vue'
import Vuex from 'vuex'
import VueFire from 'vuefire'
import Buefy from 'buefy'
import VueResource from 'vue-resource'
import VueMeta from 'vue-meta'

Vue.use(VueFire)
Vue.use(VueResource)
Vue.use(VueMeta);
Vue.use(Buefy, { defaultTooltipType: 'is-light',
                 defaultTooltipDelay: 1000 })

Vue.filter('formatDate', function(secondsSinceEpoch) {
  if (secondsSinceEpoch) {
    var date = new Date(secondsSinceEpoch*1000);
    return date.toDateString().slice(4) //.replace(/ /g,'_');
  }
})

Vue.filter('formatTime', function(secondsSinceEpoch) {
  if (secondsSinceEpoch) {
    var date = new Date(secondsSinceEpoch*1000);
    return date.toLocaleTimeString()
  }
})

Vue.filter('formatTimeShort', function(secondsSinceEpoch) {
  if (secondsSinceEpoch) {
    var date = new Date(secondsSinceEpoch*1000);
    return date.toLocaleTimeString().slice(0,5)
  }
})
Vue.filter('formatDateShort', function(secondsSinceEpoch) {
  if (secondsSinceEpoch) {
    var date = new Date(secondsSinceEpoch*1000);
    return date.toDateString().slice(4,10) //.replace(/ /g,'_');
  }
})

Vue.filter('formatCurrency', function(value) {
  var val = (Math.abs(value)/100).toFixed(2)
  if (value >= 0) {
    return val
  } else {
    return '-'+val
  }
})

Vue.filter('formatDecimal', function(value, places) {
  if (places === undefined) places = 2
  return parseFloat(value).toFixed(places)
})

export default Vue




// WEBPACK FOOTER //
// ./src/vueconfig.js